import faker from 'faker';

import { ITax, ITaxData } from '../tax.types';
import { Tax } from '../tax';
import { createRange } from '@/utils/helpers';

export function createRandomTax(): ITaxData {
  return {
    id: faker.datatype.number(),
    name: faker.company.companyName(),
    rate: faker.datatype.number()
  };
}

export const mockTaxesData: ITaxData[] = createRange(5).map(() =>
  createRandomTax()
);

export const mockTaxes = (data: ITaxData[] = mockTaxesData): ITax[] =>
  data.map(item => new Tax(item));
